export const plaidLinks = ['/sandbox-plaid-oauth-reply', '/plaid-oauth-reply'] as const

/** the root path contains no logic other than displaying a loading screen. we should avoid navigating there, lest the user be stuck on the loading screen until they restart the app */
export function isRootPath(pathname: string) {
  return pathname === '/' || pathname === ''
}

type NativeAppsFlyerExports = typeof import('./index')
type WebAppsFlyerExports = typeof import('./index.web')

// if this check fails, we haven't ensured that the web AppsFlyer service has the same exact export signature as the native one
true satisfies NativeAppsFlyerExports extends WebAppsFlyerExports
  ? WebAppsFlyerExports extends NativeAppsFlyerExports
    ? true
    : false
  : false
